import { useQuery } from '@tanstack/react-query';
import { auth } from '../config/firebase';

export const useBrand = (brandId: string) => {
  return useQuery({
    queryKey: ['brand', brandId],
    queryFn: async () => {
      const token = await auth.currentUser?.getIdToken();
      if (!token) {
        throw new Error('No authentication token available');
      }

      const response = await fetch(`https://api.socialness.ai/management/brands?brandId=${brandId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch brand');
      }

      const result = await response.json();
      
      // Check if the response has the expected structure
      if (result.brand) {
        // Single brand response format
        return result.brand;
      } else if (result.brands && Array.isArray(result.brands)) {
        // Brands array response format - find the specific brand
        const brand = result.brands.find((b: any) => b.id === brandId);
        if (!brand) {
          throw new Error('Brand not found in response');
        }
        return brand;
      } else {
        throw new Error('Invalid response structure from API');
      }
    },
    enabled: !!brandId // Only run the query if we have a brandId
  });
};